import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Made with love</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-xs-12 col-md-4 text-center"
                >
                  {d.icon.startsWith("/") ? (
                    <img
                      src={d.icon}
                      alt={d.title}
                      style={{
                        width: "64px",
                        height: "64px",
                        marginBottom: "10px",
                      }}
                    />
                  ) : (
                    <i className={`fa ${d.icon}`}></i>
                  )}
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
